import React, { useEffect, useMemo, useState } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";

function RightReserve() {
  const STORAGE_KEY = "mm_rights_notice_v1";

  const [open, setOpen] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  useEffect(() => {
    // show once
    try {
      const seen = localStorage.getItem(STORAGE_KEY);
      if (!seen) setOpen(true);
    } catch (e) {
      // if storage blocked, still show
      setOpen(true);
    }
  }, []);

  const year = useMemo(() => new Date().getFullYear(), []);

  const closeAndPersist = () => {
    try {
      if (dontShowAgain) localStorage.setItem(STORAGE_KEY, "1");
    } catch (e) {
      // ignore
    }
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={closeAndPersist}
      center
      closeOnOverlayClick={true}
      closeOnEsc={true}
      classNames={{
        overlay: "mmOverlay",
        modal: "mmModal",
        closeButton: "mmCloseBtn",
      }}
    >
      <div className="mmHeader">
        <div className="mmTitle">
          Copyright © {year} RedRadar Mirads Academy
        </div>
        <div className="mmSubtitle">All rights reserved.</div>
      </div>

      <div className="mmBody">
        <div className="mmNotice">
          All content on this website, including text, images, graphics, audio files, and other materials,
          is the property of RedRadar Mirads Academy and is protected by copyright law. No part of this website
          may be reproduced, distributed, or transmitted in any form or by any means, without prior written
          permission of the copyright owner, except for brief quotations in reviews and other noncommercial
          uses permitted by law.
        </div>

        <div className="mmDivider" />

        <div className="mmNotice">
          This website may contain links to external websites that are not provided or maintained by or in
          any way affiliated with RedRadar Mirads Academy. RedRadar Mirads Academy does not guarantee the accuracy,
          relevance, timeliness, or completeness of any information on these external websites.
        </div>

        <div className="mmActions">
          <label className="mmCheckbox">
            <input
              type="checkbox"
              checked={dontShowAgain}
              onChange={(e) => setDontShowAgain(e.target.checked)}
            />
            <span>Don&apos;t show this again</span>
          </label>

          <div className="mmBtnRow">
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={closeAndPersist}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-dark btn-sm"
              onClick={closeAndPersist}
            >
              I Understand
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default RightReserve;
